/**
 * A grid column's id: its declared id, or else its field, with every "." turned into "_". SlickGrid1 names every
 * column this way, so saved and default grid views name a column by it: `toColumnId("purchaseUnit.name")` is the
 * column whose field is `purchaseUnit.name`.
 */
export const toColumnId = (idOrField: string): string =>
  idOrField.replace(/\./g, "_");
